module.exports = __webpack_public_path__ + "img/img_size4_hc.2b182cb6.png";